// /src/pages/private/members/CalendarCustomToolbar.jsx

import React from 'react';
import moment from 'moment';

const CustomToolbar = (toolbar) => {
    const goToBack = () => {
        toolbar.onNavigate('PREV');
        handleNavigationChange(toolbar.date, toolbar.view, 'back');
    };

    const goToNext = () => {
        toolbar.onNavigate('NEXT');
        handleNavigationChange(toolbar.date, toolbar.view, 'next');
    };

    const goToToday = () => {
        toolbar.onNavigate('TODAY');
        handleNavigationChange(toolbar.date, toolbar.view, 'today');
    };

    const goToMonthView = () => {
        toolbar.onView('month'); // Change la vue sans appeler handleNavigationChange
    };

    const goToWeekView = () => {
        toolbar.onView('week'); // Change la vue sans appeler handleNavigationChange
    };

    const goToDayView = () => {
        toolbar.onView('day'); // Change la vue sans appeler handleNavigationChange
    };

    const handleNavigationChange = (date, view, direction) => {
        //console.log("handleNavigationChange called with date, view, direction:", date, view, direction);
        let start, end;
    
        if (view === 'month') {
            if (direction === 'next') {
                start = moment(date).add(1, 'month').startOf('month').subtract(1, 'weeks').toISOString();
                end = moment(date).add(1, 'month').endOf('month').add(1, 'weeks').toISOString();
            } else if (direction === 'back') {
                start = moment(date).subtract(1, 'month').startOf('month').subtract(1, 'weeks').toISOString();
                end = moment(date).subtract(1, 'month').endOf('month').add(1, 'weeks').toISOString();
            } else {
                start = moment(date).startOf('month').subtract(1, 'weeks').toISOString();
                end = moment(date).endOf('month').add(1, 'weeks').toISOString();
            }
        } else if (view === 'week') {
            if (direction === 'next') {
                start = moment(date).add(1, 'week').startOf('week').subtract(1, 'weeks').toISOString();
                end = moment(date).add(1, 'week').endOf('week').add(1, 'weeks').toISOString();
            } else if (direction === 'back') {
                start = moment(date).subtract(1, 'week').startOf('week').subtract(1, 'weeks').toISOString();
                end = moment(date).subtract(1, 'week').endOf('week').add(1, 'weeks').toISOString();
            } else {
                start = moment(date).startOf('week').subtract(1, 'weeks').toISOString();
                end = moment(date).endOf('week').add(1, 'weeks').toISOString();
            }
        } else if (view === 'day') {
            if (direction === 'next') {
                start = moment(date).add(1, 'day').startOf('day').subtract(1, 'weeks').toISOString();
                end = moment(date).add(1, 'day').endOf('day').add(1, 'weeks').toISOString();
            } else if (direction === 'back') {
                start = moment(date).subtract(1, 'day').startOf('day').subtract(1, 'weeks').toISOString();
                end = moment(date).subtract(1, 'day').endOf('day').add(1, 'weeks').toISOString();
            } else {
                start = moment(date).startOf('day').subtract(1, 'weeks').toISOString();
                end = moment(date).endOf('day').add(1, 'weeks').toISOString();
            }
        }

        //console.log("New start and end dates for navigation:", start, end);
        window.dispatchEvent(new CustomEvent('calendar-period-change', {
            detail: { start, end }
        }));
    
        if (direction === 'today') {
            toolbar.onNavigate('TODAY');
        } else {
            toolbar.onNavigate(direction === 'next' ? 'NEXT' : 'PREV');
        }
    };
    
    return (
        <div className="calendar-toolbar-container">
            <div className="rbc-toolbar left">
                <button className="btn-style1 first" onClick={goToBack}> ⮜⮜ </button>
                <button className="btn-style1 middle" onClick={goToToday}>Today</button>
                <button className="btn-style1 last" onClick={goToNext}> ⮞⮞ </button>
            </div>
            <span className="rbc-toolbar-label">{toolbar.label}</span>
            <div className="rbc-toolbar right">
                <button className="btn-style1 first" onClick={goToMonthView}>Month</button>
                <button className="btn-style1 middle" onClick={goToWeekView}>Week</button>
                <button className="btn-style1 last" onClick={goToDayView}>Day</button>

            </div>
        </div>
    );
};

export default CustomToolbar;